import { UPLOAD_S3FILES,GET_S3FILES } from '../types'

const INITIAL_STATE = {
  uploadFiles: [],
  getS3FileByKey: [],
}

const s3Reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case UPLOAD_S3FILES:
      return {
        ...state,
        uploadFiles: payload.data,
      }
    case GET_S3FILES:
      return {
        ...state,
        getS3FileByKey: payload.data,
      }
    default:
      return state
  }
}

export default s3Reducer
